<div class="visualizador-fundo" *ngIf="aberto">
  <section class="visualizador" role="dialog" aria-modal="true" aria-labelledby="titulo-visualizador">
    <header class="visualizador-cabecalho">
      <h2 id="titulo-visualizador">{{ nome }}</h2>
      <div class="visualizador-acoes">
        <button #fecharBotao type="button" class="btn btn-default btn-sm" (click)="fechar()">Fechar</button>
      </div>
    </header>
    <p *ngIf="carregando" class="visualizador-mensagem" role="status">Preparando visualização do documento...</p>
    <div *ngIf="erro" class="alert alert-danger visualizador-mensagem" role="alert">
      {{ erro }}
      <button type="button" class="btn btn-default btn-sm" (click)="carregar()">Tentar novamente</button>
    </div>
    <div class="visualizador-imagem" *ngIf="url && imagem"><img [src]="url" [alt]="nome" (error)="erro = 'Não foi possível exibir esta imagem neste navegador.'"></div>
    <iframe *ngIf="urlSegura && markdown" sandbox="" [src]="urlSegura" [title]="nome"></iframe>
    <iframe *ngIf="urlSegura && !imagem && !markdown" [src]="urlSegura" [title]="'Visualização de ' + nome"></iframe>
  </section>
</div>
